import { Link, LinkProps } from '@mui/material';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const LinkWrapper: React.FC<LinkProps & { component?: any }> = ({ component, ...props }) => (
  <Link {...props} component={component} />
);

export default LinkWrapper;
